const usePreProcessGenerateDocumentLogic = () => {
  const preprocessGenerateDocumentLogic = (selectedDocuments) => {
    return selectedDocuments;
  };
  return { preprocessGenerateDocumentLogic };
};

export default usePreProcessGenerateDocumentLogic;
